export const SECOND = 1000;
export const MINUTE = 60;

export const TOKEN_ERROR = 401;

export const noop = () => {};
